import Vue from 'vue'
import Vuex from 'vuex'
import searchPlugin from 'vuex-search';
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
	key: 'kaernten-card-store',
	storage: window.localStorage,
	// filter: (mutation) => mutation.type == /FETCH_.*/ || /UPDATE_.*/ || /CREATE_.*/ || /REMOVE_.*/
	reducer: (state) => ({
		bookmarks: state.bookmarks,
		language: state.language,
		season: state.season,
		cards: state.cards
	})
})

Vue.use(Vuex)

import state from './state.js'
import mutations from './mutations.js'
import actions from './actions.js'
import getters from './getters.js'

export default new Vuex.Store({
	state: state,
	mutations: mutations,
	actions: actions,
	getters: getters,
	plugins: [
		vuexLocal.plugin,
		searchPlugin({
			resources: {
				companies: {
					// what fields to index
					index: ['title', 'category', 'address'],
					// access the state to be watched by Vuex Search
					getter: (state) => {
						return state.companies
							.filter(company => company.language === state.language)
							.filter(company => company.season === state.season)
					},
					// how resource should be watched
					watch: { delay: 500 },
				},
				salespoints: {
					index: ['title'],
					getter: (state) => {
						return state.salespoints
							// .filter(sale => sale.language === state.language)
							.filter(sale => sale.season === state.season)
					},
					watch: { delay: 500 },
				}
				// otherResource: { index, getter, watch, searchApi },
			},
		}),
	],
})
